// extracted by mini-css-extract-plugin
export default {"footNote":"artistSettings_footNote__n3yK0","empty":"artistSettings_empty__Blw4q","emptyTitle":"artistSettings_emptyTitle__GtY5r","emptyText":"artistSettings_emptyText__-ozAT"};